export const BACK_TO_ADMINISTRATION = 'Back to Administration';

export const SELECT_ALL = 'Select All';
